"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallbackResolver = void 0;
/**
 * Static helper class for resolving callbacks for conversation sessions
 */
class CallbackResolver {
    /**
     * Find callbacks for a given session, trying multiple resolution methods
     */
    static getCallbacksForSession(activeSessions, pendingCallbacks, sessionId, tempKey) {
        // Try to find callbacks by sessionId first
        let callbacks = activeSessions.get(sessionId);
        // If not found and we have a tempKey, try that
        if (!callbacks && tempKey) {
            callbacks = pendingCallbacks.get(tempKey);
        }
        // If still not found, try partial matching for sessionId
        if (!callbacks) {
            for (const [key, cb] of activeSessions.entries()) {
                if (key.includes(sessionId)) {
                    return cb;
                }
            }
        }
        return callbacks;
    }
    /**
     * Try to find callbacks by sessionId first, then by tempKey
     */
    static resolveCallbacks(activeSessions, pendingCallbacks, sessionId, tempKey) {
        let callbacks = activeSessions.get(sessionId);
        if (!callbacks && tempKey) {
            callbacks = pendingCallbacks.get(tempKey);
        }
        return callbacks;
    }
    /**
     * Find callbacks and execute a specific callback method safely
     */
    static executeCallback(activeSessions, pendingCallbacks, sessionId, tempKey, callbackName, ...args) {
        const callbacks = CallbackResolver.getCallbacksForSession(activeSessions, pendingCallbacks, sessionId, tempKey);
        if (callbacks && callbacks[callbackName]) {
            try {
                callbacks[callbackName](...args);
                return true;
            }
            catch (error) {
                console.error(`Error executing callback ${String(callbackName)}:`, error);
                return false;
            }
        }
        return false;
    }
}
exports.CallbackResolver = CallbackResolver;
